/**
 * The screen a respondent sees between their last answer and the completion redirect (spec 47,
 * task 4b) — covers whatever is still in flight (a final follow-up poll, `/complete` itself, or
 * `/complete`'s own retries) and, once those are exhausted, offers a manual retry rather than
 * stranding the respondent on a spinner with no way forward.
 */
import React from 'react';
import { Loader2 } from 'lucide-react';
import { UI_TEXT } from '../../config/ui-text';

const T = UI_TEXT.HUMAN_SURVEY.SESSION;

interface SurveyFinishingProps {
  failed: boolean;
  onRetry: () => void;
}

export const SurveyFinishing: React.FC<SurveyFinishingProps> = ({ failed, onRetry }) => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6" role="status" aria-live="polite">
    <div className="max-w-md w-full bg-white rounded-2xl shadow-sm p-8 text-center space-y-4">
      {!failed && <Loader2 className="w-8 h-8 animate-spin mx-auto text-[#07E5D1]" />}
      <h1 className="text-xl font-semibold text-gray-900">{T.FINISHING.TITLE}</h1>
      <p className="text-gray-600">{T.FINISHING.BODY}</p>
      {failed && (
        <>
          <p className="text-amber-700 text-sm">{T.ERRORS.COMPLETE_FAILED}</p>
          <button
            type="button"
            data-testid="finish-survey"
            onClick={onRetry}
            className="min-h-[44px] px-6 rounded-lg bg-[#07E5D1] text-gray-900 font-medium"
          >
            {T.BUTTONS.FINISH_SURVEY}
          </button>
        </>
      )}
    </div>
  </div>
);

export default SurveyFinishing;
